import { Role } from "@ses-mams/api-contract";
import { useArraysIntersect } from "@ses-mams/react-utils";
import { useAuth } from "./AuthContextProvider";

export const useHasAnyRole = (roles: Role[]) => {
  const { member } = useAuth();

  return useArraysIntersect(roles, member?.roles ?? []);
};
